import {
  Box,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  sendMessages,
  sendSpecificMessages,
} from "../../features/appointments/appointmentSlice";
import { SendOTP } from "../../utils/constants";
import AppButton from "../common/AppButton";
import AppErrorMessage from "../common/AppErrorMessage";
import LoadingSpinner from "../common/Loading";
export enum SendSmsByRole {
  DOCTOR = 0,
  HEALTH_UNIT = 1,
  PATIENT = 2,
  SPECIFICUSER = 3,
}

export enum NotifyFlags {
  SMS = 0,
  NOTIFICATION = 1,
  BOTH = 2,
}
interface IProps {
  handleClose: () => void;
  setOpenSnackbar: () => void;
  appoinmentId: string;
}
const SendSmsModel = ({
  handleClose,
  setOpenSnackbar,
  appoinmentId,
}: IProps) => {
  const [formState, setFormState] = useState({
    id: "",
    message: "",
    role: "",
  });
  const dispatch = useAppDispatch();
  const [role, setRole] = useState("");
  const [state, setState] = useState({
    sms: true,
    notification: false,
  });
  const [sendMessage, setsendMessage] = useState({
    AllDoctors: false,
    AllHealthUnits: false,
    AllPatients: false,
    SpecificUser: false,
  });
  const { sms, notification } = state;
  const { AllHealthUnits, AllDoctors, AllPatients, SpecificUser } = sendMessage;
  const { isAddExpensesError, isAddExpensesLoading, addExpensesMessage } =
    useAppSelector((state: any) => state.appointments);
  const handleSubmit = (e: any) => {
    if (sendMessage.SpecificUser === false) {
      e.preventDefault();
      let users_to_sends: any = [];
      if (sendMessage.AllDoctors) {
        users_to_sends.push(SendSmsByRole.DOCTOR);
      }
      if (sendMessage.AllPatients) {
        users_to_sends.push(SendSmsByRole.PATIENT);
      }
      if (sendMessage.AllHealthUnits) {
        users_to_sends.push(SendSmsByRole.HEALTH_UNIT);
      }
      if (sendMessage.SpecificUser) {
        users_to_sends.push(SendSmsByRole.SPECIFICUSER);
      }
      const obj = {
        users_to_send: users_to_sends,
        message_body: formState.message,
      };

      dispatch(sendMessages(obj)).then((res) => {
        if (res.payload.success === true) {
          setOpenSnackbar();
          handleClose();
        }
      });
    } else {
      e.preventDefault();
      let users_to_sends: any = [];
      if (sendMessage.AllDoctors) {
        users_to_sends.push(SendSmsByRole.DOCTOR);
      }
      if (sendMessage.AllPatients) {
        users_to_sends.push(SendSmsByRole.PATIENT);
      }
      if (sendMessage.AllHealthUnits) {
        users_to_sends.push(SendSmsByRole.HEALTH_UNIT);
      }
      if (sendMessage.SpecificUser) {
        users_to_sends.push(SendSmsByRole.SPECIFICUSER);
      }
      const objs = {
        users_to_send: users_to_sends,
        message_body: formState.message,
      };
      dispatch(sendMessages(objs)).then((res) => {
        if (res.payload.success === true) {
          setOpenSnackbar();
          handleClose();
        }
      });
      e.preventDefault();
      let notify_flag: any;
      if (state.notification && state.sms) {
        notify_flag = NotifyFlags.BOTH;
      } else if (state.notification) {
        notify_flag = NotifyFlags.NOTIFICATION;
      } else if (state.sms) {
        notify_flag = NotifyFlags.SMS;
      }
      const obj = {
        id: formState.id,
        role: formState.role,
        message: formState.message,
        notify: notify_flag,
      };
      dispatch(sendSpecificMessages(obj)).then((res) => {
        if (res.payload.success === true) {
          setOpenSnackbar();
          handleClose();
        }
      });
    }
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
  };
  const handleSendChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setsendMessage({
      ...sendMessage,
      [event.target.name]: event.target.checked,
    });
  };
  const handlRoleChange = (event: SelectChangeEvent) => {
    setRole(event.target.value as string);
    setFormState({
      ...formState,
      role: event.target.value,
    });
  };
  return (
    <Box onSubmit={handleSubmit} component="form">
      {isAddExpensesLoading ? (
        <LoadingSpinner style={{ minHeight: "40vh" }} />
      ) : (
        <Box
          sx={{
            px: 2,
            pt: 2,
          }}
        >
          <Box>
            <Typography variant="body1" sx={{ fontWeight: "bold" }}>
              Message Type:
            </Typography>
            <FormControl sx={{ m: 1 }} component="fieldset" variant="standard">
              <FormGroup sx={{ dialay: "flex", flexDirection: "row" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={sms}
                      onChange={handleChange}
                      name="sms"
                    />
                  }
                  label="SMS"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={notification}
                      onChange={handleChange}
                      name="notification"
                    />
                  }
                  label="Notification"
                />
              </FormGroup>
            </FormControl>
          </Box>
          <Box>
            <Typography variant="body1" sx={{ fontWeight: "bold" }}>
              Send to:
            </Typography>

            <FormControl sx={{ m: 1 }} component="fieldset" variant="standard">
              <FormGroup sx={{ dialay: "flex", flexDirection: "row" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={AllDoctors}
                      onChange={handleSendChange}
                      name="AllDoctors"
                    />
                  }
                  label="All Doctors"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={AllHealthUnits}
                      onChange={handleSendChange}
                      name="AllHealthUnits"
                    />
                  }
                  label="All Health Units"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={AllPatients}
                      onChange={handleSendChange}
                      name="AllPatients"
                    />
                  }
                  label="All Patients"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={SpecificUser}
                      onChange={handleSendChange}
                      name="SpecificUser"
                    />
                  }
                  label="Specific User"
                />
              </FormGroup>
            </FormControl>
          </Box>
          {sendMessage.SpecificUser === true ? (
            <>
              <Box sx={{ width: "100%" }}>
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                  User id
                </Typography>

                <TextField
                  fullWidth
                  required
                  type="number"
                  InputProps={{ inputProps: { min: 0 } }}
                  onChange={(e: any) =>
                    setFormState({
                      ...formState,
                      id: e.target.value,
                    })
                  }
                />
              </Box>
              <Box sx={{ width: "100%" }}>
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                  User Role
                </Typography>
                <FormControl fullWidth>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={role}
                    label="Doctor"
                    onChange={handlRoleChange}
                  >
                    {SendOTP.map((item, index) => (
                      <MenuItem key={index} value={item.id}>
                        {item.title}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </>
          ) : null}
          <Box
            sx={{
              width: "100%",
              mt: 1,
            }}
          >
            <Typography variant="body1" sx={{ fontWeight: "bold" }}>
              Message Content
            </Typography>
            <Box
              sx={{
                display: "flex",
              }}
            >
              <TextField
                id="outlined-multiline-static"
                multiline
                rows={4}
                fullWidth
                required
                onChange={(e: any) =>
                  setFormState({
                    ...formState,
                    message: e.target.value,
                  })
                }
              />
            </Box>
          </Box>
          <Box sx={{ width: "100%", mt: 3 }}>
            {isAddExpensesError ? (
              <AppErrorMessage message={addExpensesMessage} />
            ) : null}
          </Box>
          <Box sx={{ width: "100%", mt: 5 }}>
            <Divider />
            <AppButton title="Send" sx={{ float: "right", margin: "10px" }} />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default SendSmsModel;
